<template>
  <BasePage title="Library" :container="true" class="main-container">

    <div class="container profile">
      <div class="section profile-heading">
        <div class="columns">

          <Loader v-if="loading"/>

            <div v-if="!loading && library" class="column name">
              <p>
                <span class="title is-bold" v-if="!editing && library.title">{{ library.title }}</span>
                <input type="text" v-if="editing && library.title" class="input" :value="library.title" ref="title" />
                <textarea type="text" v-if="editing && library.description" class="textarea" :value="library.description" ref="description" />
                <input v-if="!editing" @click="editing = true" type="button" name="Edit" value="Edit" class="button is-primary is-outlined follow"/>
                <input v-if="editing" @click="editing = false" type="button" name="Cancel" value="Cancel" class="button is-primary is-outlined follow"/>
                <input v-if="editing" @click="updateLibrary" type="button" name="Save" value="Save" class="button is-info follow"/>
              </p>
              <p class="tagline" v-if="!editing && library.description"> {{ library.description }}</p>
            </div>
            <div v-if="!loading && library" class="column is-3 following has-text-centered">
              <p class="stat-val" >{{ videos.length }}</p>
              <p class="stat-key">videos</p>
            </div>

        </div>
      </div>
    </div>

    <div class="box">
      <section class="search-box-container">
        <input class="input search-box" type="text" placeholder="Search for a video" v-model='query'>
        <input
          @click="showAddVideoModal = true"
          type='button'
          class='button is-warning'
          value='+ Add Video'
          name='add video'/>
      </section>
    </div>



    <div v-if="!loading && library" class="card-container">
      <LibraryVideo v-if="searchResults.length > 0" v-for="video in searchResults" :key='video.id' :video='video' :libraryID='libraryID' />
      <div v-if="searchResults.length === 0" >
        <h1>No videos match <strong>"{{query}}"</strong></h1>
      </div>
    </div>

    <AddVideoModal
      :cycleID = -99
      :videoID = -99
      :hideCycles = "true"
      @close="showAddVideoModal = false"
      v-if="showAddVideoModal" />
  </BasePage>

</template>

<script>
  import store from '../store.js'

  import Loader from './Loader.vue'
  import AddVideoModal from './AddVideoModal.vue'
  import BasePage from './BasePage.vue'
  import LibraryVideo from './LibraryVideo.vue'

  export default {
    name: 'Library',
    components: {
      Loader,
      AddVideoModal,
      BasePage,
      LibraryVideo,
    },
    data () {
      return {
        editing: false,
        query: '',
        showAddVideoModal: false,
      }
    },
    methods: {
      updateLibrary () {
        const { library } = this
        store.dispatch('updateLibrary', { libraryID: library.id, title: library.title, description: library.description })
      },
    },
    mounted () {
      store.dispatch('fetchLibrary', this.libraryID)
    },
    computed: {
      libraryID () {
        return parseInt(this.$route.params.id, 10)
      },
      library () {
        return store.state.activeLibrary
      },
      videos () {
        return this.library.videos
      },
      loading () {
        return store.state.loadingLibraryData
      },
      searchResults () {
        if (this.videos == null) {
          return []
        }
        return this.videos.filter(x => {
          return x.title.toUpperCase().includes(this.query.toUpperCase()) ||
                 x.content_area.toUpperCase().includes(this.query.toUpperCase()) ||
                 x.grade.toUpperCase().includes(this.query.toUpperCase())
        })
      },
    },
  }
</script>

<style lang="scss" scoped>
  .search-box-container {
    display: flex;
    justify-content: space-between;
  }

  .search-box {
    flex-grow: 1;
    margin-right: 1rem;
  }

  .card-container {
    display: flex;
    flex-wrap: wrap;
  }

</style>



// WEBPACK FOOTER //
// Library.vue?759031e8